<template>
  <div
    class="mb-2 d-flex"
    style="margin-left: 3.95rem; flex-wrap: wrap">
    <TagV2
      v-for="item in visibleTags"
      :key="item.id"
      :data="item" />
    <!-- <el-popover
      v-if="ellipsisTag.length"
      width="100px"
      trigger="hover">
      <div
        slot="reference"
        class="z2-tag-count">
        {{ ellipsisTag.length }}+
      </div>
      <div>
        <TagV2
          v-for="item in ellipsisTag"
          :key="item.id"
          :data="item" />
      </div>
    </el-popover> -->
  </div>
</template>

<script>
import TagV2 from "./TagV2.vue";

export default {
  props: ["tags"],
  components: {
    TagV2,
  },
  data() {
    return {
      CONTAINER_TAG_WIDTH: 175,
    };
  },
  computed: {
    visibleTags() {
      const list = this.tags.filter((data) => this.filterTag(data));
      list.sort((a, b) => a.createAt - b.createAt);
      return list;
      // let totalWidth = 0;
      // let visibleTags = [];
      // const tagList = this.tags.filter((data) => this.filterTag(data));
      // for (let i = 0; i < tagList.length; i++) {
      //   const tagWidth = this.getTagWidth(tagList[i]);
      //   if (i === 0 || totalWidth + tagWidth <= this.CONTAINER_TAG_WIDTH) {
      //     visibleTags.push(tagList[i]);
      //     totalWidth += tagWidth;
      //   } else {
      //     break;
      //   }
      // }
      // return visibleTags;
    },
    ellipsisTag() {
      const tagList = this.tags.filter((data) => this.filterTag(data));
      return tagList.slice(this.visibleTags.length);
    },
  },
  methods: {
    getTagWidth(data) {
      const content = data.assign ? "* " + data.name : data.name;
      const averageCharacterWidth = 8;
      return content.length * averageCharacterWidth + 4;
    },
    filterTag(data) {
      let filter = this.app.tags.filter((t) => t.id == data.id);
      if (filter && filter.length > 0) return true;
      return false;
    },
  },
};
</script>

<style>
</style>